import React from 'react'

const StarIcon = () => {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M7.98572 0.287513C7.85197 0.293138 7.73572 0.381263 7.69447 0.508761L6.18759 5.17996L1.28071 5.16996C1.14196 5.16996 1.01821 5.25934 0.975716 5.39121C0.932591 5.52371 0.980091 5.66809 1.09259 5.74996L5.06891 8.62676L3.54203 13.293C3.49891 13.4249 3.54578 13.5699 3.65828 13.6511C3.77016 13.733 3.92265 13.733 4.03454 13.6511L7.9995 10.758L11.9657 13.6511C12.0776 13.733 12.2301 13.733 12.342 13.6511C12.4545 13.5699 12.5014 13.4249 12.4582 13.293L10.9314 8.62676L14.9077 5.74996C15.0202 5.66809 15.0677 5.52371 15.0246 5.39121C14.9814 5.25933 14.8583 5.16996 14.7196 5.17059L9.81269 5.18059L8.30393 0.509385V0.50876C8.25956 0.371885 8.12957 0.28188 7.98581 0.287512L7.98572 0.287513Z" fill="#E9B200"/>
</svg>

  )
}

export default StarIcon